varying float vLifetime;
varying vec3 vColor;

void main() {
    // 円形のパーティクルを描画
    float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
    if (distanceToCenter > 0.5) {
        discard; // 円の外側は描画しない
    }

    vec3 color = mix(vec3(0.9216, 0.8039, 0.1294), vColor, vLifetime);

    // 透明度。縁と寿命の終わり際にフェードアウト
    float alpha = (1.0 - distanceToCenter) * vLifetime * 0.6;

    gl_FragColor = vec4(color, 0.4 + alpha);
}